import { postRequest, ApiResponse } from "@/data/apiClient";
import { UserDetails } from "@/data/repos/commonModels";

export interface userCreateResponse {
  id: number;
}

export const userCreate = async (
  user: UserDetails
): Promise<ApiResponse<userCreateResponse>> => postRequest("user/create", user);
